import { Outlet } from 'react-router'
import Breadcrumb from '@/components/breadcrumbs/Breadcrumb'
import PageTitle from '@/components/PageTitle'

export default function ListsPage() {
  return (
    <>
      <PageTitle>Lists</PageTitle>
      <Breadcrumb label="Lists" url="/settings/lists" />
      <Outlet />
    </>
  )
}
